<template>
  <DialogPortal
    :disabled="disablePortal"
  >
    <DialogOverlay
      :class="
        cn(
          'tw:fixed tw:inset-0 tw:z-100 tw:grid tw:place-items-center tw:overflow-y-auto tw:bg-black/20 tw:data-[state=open]:animate-in tw:data-[state=closed]:animate-out tw:data-[state=closed]:fade-out-0 tw:data-[state=open]:fade-in-0',
          'tw:data-[state=closed]:hidden',
        )"
    >
      <DialogContent
        :aria-describedby="undefined"
        :class="
          cn(
            'tw:focus-visible:outline-hidden tw:relative tw:py-6 tw:z-100 tw:grid tw:w-11/12 tw:rounded-lg tw:max-w-lg tw:my-8 tw:gap-4 tw:border tw:border-border/20 tw:bg-background tw:shadow-lg tw:duration-200 tw:md:w-full',
            'tw:dark:border-border',
            props.class,
          )
        "
        v-bind="forwarded"
        @interact-outside="onInteractOutside"
        @open-auto-focus="onOpenAutoFocus"
        @pointer-down-outside="
          (event) => {
            const originalEvent = event.detail.originalEvent;
            const target = originalEvent.target;
            if (
              originalEvent.offsetX > target.clientWidth
              || originalEvent.offsetY > target.clientHeight
            ) {
              event.preventDefault();
            }
          }
        "
      >
        <slot />

        <DialogClose
          v-if="canClose"
          :class="cn(
            'tw:absolute tw:leading-none tw:right-4 tw:top-4 tw:rounded-sm tw:opacity-70 tw:ring-offset-background tw:transition-opacity tw:hover:opacity-100 tw:focus:outline-hidden tw:focus:ring-2 tw:focus:ring-ring tw:focus:ring-offset-2 tw:disabled:pointer-events-none tw:data-[state=open]:bg-accent tw:data-[state=open]:text-muted-foreground',
            'tw:text-foreground',
          )"
        >
          <i class="tw:i-fal-xmark tw:size-4" />
          <span class="tw:sr-only">Close</span>
        </DialogClose>
      </DialogContent>
    </DialogOverlay>
  </DialogPortal>
</template>

<script setup>
import {
  DialogClose,
  DialogContent,
  DialogOverlay,
  DialogPortal,
  useForwardPropsEmits,
} from 'reka-ui'
import { computed } from 'vue'
import { cn } from '@/shadcn/lib/utils'
import { useDialogContent } from './useDialogContent.js'

const props = defineProps({
  forceMount: { type: Boolean, required: false },
  trapFocus: { type: Boolean, required: false },
  disableOutsidePointerEvents: { type: Boolean, required: false },
  asChild: { type: Boolean, required: false },
  as: { type: null, required: false },
  class: { type: null, required: false },
  disablePortal: { type: Boolean, required: false },
  canClose: { type: Boolean, default: true },
  isStaticBackdrop: { type: Boolean, default: false },
})
const emits = defineEmits([
  'escapeKeyDown',
  'pointerDownOutside',
  'focusOutside',
  'interactOutside',
  'openAutoFocus',
  'closeAutoFocus',
])

const delegatedProps = computed(() => {
  const { class: _, ...delegated } = props

  return delegated
})

const forwarded = useForwardPropsEmits(delegatedProps, emits)

const { onInteractOutside, onOpenAutoFocus } = useDialogContent(props)
</script>
